import { css } from "@emotion/css";
import React from "react";
import { RadioGroupProps } from "react-aria-components";

import { _RadioGroup } from "./assets/_RadioGroup";
import { _Text } from "../../../_assets/_Text";
import {
  FieldErrors,
  FieldErrorsProps,
} from "../../_assets/input-wrapper/FieldErrors";
import { FormLabelRAC } from "../../_assets/input-wrapper/FormLabelRAC";

export interface RadioGroupPropsRAC extends Omit<RadioGroupProps, "children"> {
  children?: React.ReactNode;
  label?: string;
  info?: string;
  description?: string;
  errors?: FieldErrorsProps["children"];
  isCard?: boolean | undefined;
  testID?: string;
}

interface RadioGroupRACContextType {
  isCard?: boolean;
}

export const RadioGroupRACContext =
  React.createContext<RadioGroupRACContextType>({
    isCard: false,
  });

export function RadioGroupRAC(props: RadioGroupPropsRAC) {
  const { label, info, description, errors, children, ...radioGroupProps } =
    props;

  return (
    <RadioGroupRACContext.Provider value={{ isCard: props.isCard }}>
      <_RadioGroup {...radioGroupProps}>
        {props.label && (
          <FormLabelRAC isRequired={props.isRequired} info={props.info}>
            {props.label}
          </FormLabelRAC>
        )}
        {/* confirmed with design we will not be use cards horizontally */}
        {props.orientation === "horizontal" && !props.isCard ? (
          <div className={css(styles.horizontal)}>{children}</div>
        ) : (
          children
        )}
        {description && (
          <_Text slot="description" style="input/helper" color="text-weak">
            {description}
          </_Text>
        )}
        <FieldErrors>{errors}</FieldErrors>
      </_RadioGroup>
    </RadioGroupRACContext.Provider>
  );
}

// RAC places the radio buttons in line with the label when using horizontal so we need custom styling
const styles = {
  horizontal: css({
    display: "flex",
    gap: "var(--space-6)",
    width: "fit-content",
  }),
};
